var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('schedule-delegation-settings',{attrs:{"delegationSettings":_vm.user,"handleToggleDelegation":_vm.toggleDelegation,"toggleDelegationRequest":_vm.toggleDelegationRequest}})}
var staticRenderFns = []

export { render, staticRenderFns }